export const COMPARE_QUESTION =
  'Do you compare your communication skills to others?'

export const COMPARE_OPTIONS = [
  { key: 'aLot', i18nKey: 'aLot' },
  { key: 'sometimes', i18nKey: 'sometimes' },
  { key: 'notOften', i18nKey: 'notOften' },
] as const
